import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react'
import style from './NewNote.module.less'
import NotePage from '@/views/NoteV2'
import { atom, useAtom } from 'jotai';
import { FullScreen, closeEditor } from '@/state';
import {KEYS} from "../@excalidraw/packages/excalidraw/keys";
import {useSpring} from "react-spring";
import { animated } from '@react-spring/web'
import Global from "@/global";
import {createCopyLinkByLibraryItem, createDeeplink, getIntValue} from "@/utils";
import {ResizableBox} from 'react-resizable';
import 'react-resizable/css/styles.css';
import global from "@/global";
import {debugLog} from "@/LogUtils";
import {isInSingleFloatWindow, isMac} from "@/Utility";
import {getCardById} from "@model/card";
import {postMessage} from "@/common/event";
import {EVENT_OPEN_LIBRARY_ITEM, FROM_LIBRARY} from "@/Const";
import {createPortal} from "react-dom"; // 引入默认样式

let mIsFullScreen= false;
const NewNote = forwardRef((props:{data?:any,index?:any,onRef?:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onAutoCloseUnPin:onAutoCloseUnPin,
        getIsPin:getIsPin,
        getData:getData,
        showOrHidden:showOrHidden
    }));
    const [fullScreen, setFullScreen] = useAtom(FullScreen)
    const [dialogSize,setDialogSize] = useState({width:Global.g_currentNoteFullScreen?'100vw':'0px',height:Global.g_currentNoteFullScreen?'100vh':'0px',maxHeight:'0px'})

    const mIsDragging = useRef<any>(false);
    const offset = useRef<any>({x:0,y:0});
    const divDialogRef = useRef<any>(null);
    const [isPin,setIsPin] = useState(false);

    const [hasMaskLayer,setHasMaskLayer] = useState(window.getDialogPinCount() == 0);

    const [x, setX] = useState(0); // div 的左上角 x 坐标
    const [y, setY] = useState(0); // div 的左上角 y 坐标
    // const [resizing, setResizing] = useState(null); // 当前正在拖拽的角
    const initialMousePos = useRef<any>({ x: 0, y: 0 });

    const notePageRef = useRef(null);
    const mResizing = useRef(null);
    const mIsPin = useRef<boolean>(false);


    /** ctrl+f 快捷键 搜索 */
    function lisCtrlF(e) {
        // debugLog('actionProperties',e);
        if (e.key === 'f' && (e.ctrlKey || e.metaKey)) {
            window.GSearchOpen?.()
        }else if (e.key == KEYS.ESCAPE){
            if (isPin)return;
            if (fullScreen)return;
            if (window.closePopupCardList())return;

            //AUTO SAVE
            window.GNoteSave(false,true)

            closeEditor();
            e.stopPropagation();
            e.preventDefault();
        }
    }

    function eventResize(event:any){
        // updateDialogSize()
    }

    function onMouseLeftButtonDown(event:any){
        event.stopPropagation();
        event.preventDefault();
    }
    // useEffect(()=>{
    //     document.body.addEventListener('mousedown',onMouseLeftButtonDown);
    //     return ()=>{
    //         document.body.removeEventListener('mousedown',onMouseLeftButtonDown);
    //     }
    // })

    useEffect(() => {

        mIsFullScreen = Global.g_currentNoteFullScreen;
        document.body.addEventListener('keydown', lisCtrlF);

        document.body.addEventListener('mousemove',handleMouseMove);
        document.body.addEventListener('mouseup',handleMouseUp);
        window.addEventListener('resize',eventResize);

        updateDialogSize(global.g_isCtrlPressed || props.data?.isPin);

        setHasMaskLayer(window.getDialogPinCount() == 0);
        setIsPin(props.data?.isPin);
        if (props.data?.isPin || global.g_isCtrlPressed){
            setHasMaskLayer(false);
            setIsPin(true);
        }


        return () => {
            document.body.removeEventListener('keydown', lisCtrlF);

            document.body.removeEventListener('mousemove',handleMouseMove);
            document.body.removeEventListener('mouseup',handleMouseUp);
            window.removeEventListener('resize',eventResize);

        }
    },[])

    useEffect(()=>{
        mIsFullScreen = fullScreen;
        updateDialogSize(global.g_isCtrlPressed || props.data?.isPin)
    },[fullScreen])


    /**
     * unpin情况下自动关闭
     */
    function onAutoCloseUnPin(){
        if (notePageRef.current?.getIsPin()){

        }
    }

    function getIsPin(){
        return notePageRef.current?.getIsPin();
    }

    /**
     * 显示或隐藏
     */
    function showOrHidden(){
        if (divDialogRef.current){
            if (global.g_isHiddenAllFloatWin){
                divDialogRef.current.style.opacity = 0;
                divDialogRef.current.style.display = 'none'
            }else{
                divDialogRef.current.style.opacity = 1;
                divDialogRef.current.style.display = ''
            }
        }
    }

    function getData(){
        return props.data;
    }

    async function doClose(e){
        // let {from, to} = window.GEditor.state.selection
        // if(from === to){
        //     window.GNoteSave(false,true)
        // }
        // window.GNoteSave(false,true)


        // window.closeDialogCard(props.data);
        // let bHasDialog = false;
        // if (global.g_showDialogs['dialogVideoNotes']){
        //     bHasDialog = true;
        //     window.closeUnpinDialogVideos();
        // }
        // if (global.g_showDialogs['dialogPdf']){
        //     bHasDialog = true;
        //     window.closeUnpinDialogPdf()
        // }

        window.closeUnpinDialogCard(props.data);
    }

    const updateDialogSize = (isInitPin:any)=>{
        let nWidth = '100vw';
        let nHeight = '100vh';
        let nMaxHeight = '100vh';
        if (mIsFullScreen){
            nWidth = '100vw';
            nHeight = '100vh';
        }else{
            if (isInitPin){
                nWidth = (document.body.clientWidth*0.35)+'px';
                nHeight = (document.body.clientHeight*0.7)+'px';
            }else{
                nWidth = (document.body.clientWidth*0.8)+'px';
                nHeight = (document.body.clientHeight*0.85)+'px';
            }
            nMaxHeight = (document.body.clientHeight*0.9)+'px';
        }

        setDialogSize({
            width: nWidth,
            height: nHeight,
            maxHeight:nMaxHeight
        })

        setX((document.body.clientWidth - getIntValue(nWidth.replace('px',''),0))*0.5);
        setY((document.body.clientHeight - getIntValue(nHeight.replace('px',''),0))*0.5)
    }

    const getWidth = ()=>{
        if (fullScreen){
            return  '100vw';
        }
        return (document.body.clientWidth - 480)+'px';
    }
    const getHeight = ()=>{
        if (fullScreen){
            return '100vh';
        }
        return (document.body.clientHeight - 200)+'px';
    }

    const [springs, api] = useSpring(() => ({
        from: { x: 0 },
    }))
    const handleClick = () => {
        api.start({
            from: { x: 0 },
            to: { x: 700 },
        })
    }

    // 初始化动画
    let opacity = 1;
    let current = 0; // 当前位置
    let currentHeight = 0;
    let currentWidth = 0;
    const animate = () => {

        const div = document.getElementById('divNoteContainer');
        const divContainer = document.getElementById('NOTE_V2_DOM');
        if (currentHeight == 0){
            currentHeight = div.clientHeight;
            currentWidth = div.clientWidth;
        }

        // 增加透明度直到达到1（不透明）
        opacity -= 0.025;

        if (document.body.clientHeight <= currentHeight){
            currentHeight = currentWidth = 0;
            closeEditor()
            return;
        }
        // div.style.opacity = opacity;
        div.style.transform = `translateX(${current}px)`;
        div.style.height = `${currentHeight}px`;
        div.style.width = `${currentWidth}px`;
        current +=10;
        currentHeight += 5;
        currentWidth -= 5;

        divContainer.style.opacity = opacity;
        requestAnimationFrame(animate);
    };

    // const handleResize = (event) => {
    //     setWidth(event.layout.width);
    //     setHeight(event.layout.height);
    // };

    const handleMouseDown = (corner) => (e) => {
        mResizing.current = (corner);
        initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        e.preventDefault();
        e.stopPropagation();
    };

    const handleMouseMove = (e) => {
        if (mResizing.current){
            const rect = divDialogRef.current.getBoundingClientRect();
            const deltaX = e.clientX - initialMousePos.current.x;
            const deltaY = e.clientY - initialMousePos.current.y;
            let nWidth = 0,nHeight =0;

            switch (mResizing.current) {
                case 'top-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setX(rect.left + deltaX);
                    setY(rect.top + deltaY);
                    break;
                case 'top-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case 'bottom-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    setX(rect.left + deltaX);
                    break;
                case 'bottom-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                case "left":
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = rect.height;
                    setX(rect.left + deltaX);
                    break;
                case "top":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case "right":
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = rect.height;
                    break;
                case "bottom":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                default:

                    break;
            }
            if (nWidth <= 410){
                nWidth = 410;
            }
            if (nHeight <= 300){
                nHeight = 300;
            }
            setDialogSize({
                width: nWidth+'px',
                height: nHeight+'px',
                maxHeight: '100vh'
            })

            initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        }

        if (mIsDragging.current) {
            divDialogRef.current.style.left = (event.clientX - offset.current.x) + 'px';
            divDialogRef.current.style.top = (event.clientY - offset.current.y) + 'px';
        }
    };

    const handleMouseUp = () => {
        mResizing.current = (null);
    };

    return createPortal(
        <>
            <div ref={divDialogRef}
                 className={`${style.newNoteStyle}  ${fullScreen ? style.fullScreen : null}` + ' newNote'}
                 id={'card-dialog-' + props.data?.id}
                 style={{
                     width: dialogSize.width, height: dialogSize.height,
                     left: fullScreen ? '0px' : x + 'px',
                     top: fullScreen ? '0px' : y + 'px',
                     zIndex: props.index
                 }}
                 onMouseDown={(event) => {
                     // event.stopPropagation();//乱stop 这里阻止了table的cell的拖动。。。。。
                     //最好的办法是什么也不要动....!ok
                 }}
                // onMouseMove={handleMouseMove}
                // onMouseUp={handleMouseUp}
                // onMouseLeave={handleMouseUp}
            >
                {
                    isInSingleFloatWindow() &&
                    <div className={'drag'} style={{
                        position: 'fixed',
                        left: '0',
                        top: '0',
                        height: '18px',
                        width: '100%',
                        zIndex: '0',
                        opacity: '0'
                    }}></div>
                }


                {
                    // hasMaskLayer &&
                    <div id={'newnote-card-mask-layer----'} className={!isPin?'no-drag':''} style={{
                        width: '100%',
                        height: '100%',
                        background: hasMaskLayer ? '#00000033' : 'transparent',
                        position: "fixed",
                        pointerEvents: isPin ? 'none' : 'all',
                        left: '0px',
                        top: '0px',
                    }} onClick={doClose}>
                    </div>
                }
                <div id='divNoteContainer' className={style.box} style={{
                    width: dialogSize.width,
                    height: dialogSize.height,
                    border: '1px solid var(--border-color)',
                    boxShadow: 'var(--dialog-box-shadow)'
                }}
                     onClick={(e) => {
                         if (isInSingleFloatWindow())return;
                         e.stopPropagation();
                         // e.preventDefault();!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........!!!!!这里会阻止task-item的checkbox点击事件.........
                         window.bringCardDialogFront(props.data);
                     }}>
                    <NotePage ref={notePageRef} propData={props.data} dialogSize={dialogSize}
                              onPinSet={(isPin: any) => {
                                  setIsPin(isPin);
                                  updateDialogSize(isPin);

                                  notePageRef.current?.refreshTitleHeight();

                                  setTimeout(() => {
                                      const nPinCount = window.getDialogPinCount();
                                      if (nPinCount > 0) {
                                          setHasMaskLayer(false);
                                      } else {
                                          setHasMaskLayer(!isPin);
                                      }
                                  }, 100)

                              }} eventSliderClickCallback={() => {
                        // requestAnimationFrame(animate);
                        closeEditor();
                    }} onHeaderMouseDown={(event) => {
                        if (!getIsPin()) return;
                        mIsDragging.current = true;
                        offset.current.x = event.clientX - divDialogRef.current.getBoundingClientRect().left;
                        offset.current.y = event.clientY - divDialogRef.current.getBoundingClientRect().top;
                    }} onHeaderMouseMove={(event) => {
                        if (mIsDragging.current) {
                            divDialogRef.current.style.left = (event.clientX - offset.current.x) + 'px';
                            divDialogRef.current.style.top = (event.clientY - offset.current.y) + 'px';
                        }
                    }} onHeaderMouseUp={(event) => {
                        mIsDragging.current = false;
                    }}/>
                </div>

                {/* 四个拖拽手柄 */}
                {
                    isPin &&
                    <>
                        <div className="resize-handle top-left" onMouseDown={handleMouseDown('top-left')}/>
                        <div className="resize-handle top-right" onMouseDown={handleMouseDown('top-right')}/>
                        <div className="resize-handle bottom-left" onMouseDown={handleMouseDown('bottom-left')}/>
                        <div className="resize-handle bottom-right" onMouseDown={handleMouseDown('bottom-right')}/>
                        <div className="resize-handle left" onMouseDown={handleMouseDown('left')}/>
                        <div className="resize-handle right" onMouseDown={handleMouseDown('right')}/>
                        <div className="resize-handle top" onMouseDown={handleMouseDown('top')}/>
                        <div className="resize-handle bottom" onMouseDown={handleMouseDown('bottom')}/>
                    </>
                }

                {/* 你的内容 */}
            </div>
        </>
    ,document.body)
})
export default NewNote






























